module.exports = __webpack_public_path__ + "static/portraitMob-7286737be9325e7e430676a4b06a0f4d.png";